/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export class ArgumentOperandImpl {
  constructor(expArgumentOperands, expArgumentOperandGroup, elementInfos) {
    this.expArgumentOperands = expArgumentOperands;
    this.expArgumentOperandGroup = expArgumentOperandGroup;
    this.elementInfos = elementInfos;
  }
  get argumentIdentifier() {
    return this.expArgumentOperandGroup?.id ?? this.expArgumentOperands[0].name;
  }
  get isAdvanced() {
    return this.expArgumentOperands[0].advanced ?? false;
  }
  get isOptional() {
    // Always use the group's value, unless there is no group.
    if (this.expArgumentOperandGroup != null) {
      return this.expArgumentOperandGroup.optional ?? false;
    } else {
      return this.expArgumentOperands[0].optional ?? false;
    }
  }
}
//# sourceMappingURL=ArgumentOperandImpl.js.map
